export type ColumnWidthByDeviceCount = Partial<Record<number, string>>;

export function resolveMultiDeviceColumnWidth(
  deviceCount: number,
  defaultColumnWidth: string,
  columnWidthByDeviceCount?: ColumnWidthByDeviceCount,
): string {
  if (!columnWidthByDeviceCount) {
    return defaultColumnWidth;
  }

  const counts = Object.keys(columnWidthByDeviceCount)
    .map(Number)
    .filter((value) => Number.isFinite(value))
    .sort((a, b) => a - b);

  if (!counts.length) {
    return defaultColumnWidth;
  }

  const selectedCount = counts.find((count) => deviceCount <= count) ?? counts[counts.length - 1];
  return columnWidthByDeviceCount[selectedCount] ?? defaultColumnWidth;
}

export function buildMultiDeviceGridColumns(
  columnCount: number,
  defaultColumnWidth: string,
  columnWidthByDeviceCount?: ColumnWidthByDeviceCount,
): string {
  const width = resolveMultiDeviceColumnWidth(
    Math.max(columnCount, 1),
    defaultColumnWidth,
    columnWidthByDeviceCount,
  );
  return columnCount > 0 ? `${width} repeat(${columnCount}, ${width})` : `${width} ${width}`;
}
